var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pp-blockchain-icon",domProps:{"innerHTML":_vm._s(_vm.getIcon)}})
}
var staticRenderFns = []

export { render, staticRenderFns }